<template>
    <div class="ngdialog-content">
        <dialog-header :showClose="false">
            <h4 v-if="activate">{{ $t('users.activate_title') }}</h4>
            <h4 v-else>{{ $t('users.deactivate_title') }}</h4>
        </dialog-header>

        <div class="ngdialog__body notification__info">
            <p v-if="activate">{{ $t('users.activate_text') }}</p>
            <p v-else>{{ $t('users.deactivate_text') }}</p>
        </div>

        <div class="ngdialog__button-group">
            <div class="ngdialog__button-group__item">
                <button
                    type="button"
                    class="ngdialog__button ngdialog__button--secondary"
                    @click="close"
                >
                    <span class="ngdialog__button__text">{{ $t('buttons.close') }}</span>
                </button>
            </div>
            <div class="ngdialog__button-group__item">
                <button
                    type="button"
                    class="ngdialog__button ngdialog__button--primary"
                    @click="changeUser"
                >
                    <span v-if="activate" class="ngdialog__button__text">{{ $t('users.activate_user') }}</span>
                    <span v-else class="ngdialog__button__text">{{ $t('users.deactivate_user') }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import DialogHeader from '@/components/DialogHeader';

export default {
    name: 'info-only',
    components: {
        DialogHeader,
    },
    props: {
        activate: {
            type: Boolean,
        },
        userid: {
            type: String,
        },
        successCallback: {
            type: Function,
        },
    },
    mounted() {
    },
    data() {
        return {

        };
    },
    methods: {
        close() {
            this.$emit('close');
        },
        changeUser() {
            this.$emit('close');
            this.successCallback(this.activate, this.userid);
        },
    },
};
</script>